import React from 'react';
import { Option } from 'shared/interface/globalInterface';

import InputWrapper from '../InputWrapper/InputWrapper';
import { Props } from './SelectField.types';
import { Select } from '../../components';

const SelectField: React.FC<Props> = ({
  title,
  subtitle,
  placeholder,
  field,
  form,
  disabled,
  required,
  options,
  handleClick,
  searchable,
  extraContent = [],
  noOptionsText,
  confirm,
  value = null,
}) => {
  field.value = value !== null ? value : field.value || '';

  const { setFieldValue, setFieldTouched } = form;

  const handleSelection = (option: Option) => {
    setFieldValue(field.name, option.value);

    if (handleClick) {
      handleClick(option);
    }
  };

  const handleBlur = () => setFieldTouched(field.name);

  return (
    <InputWrapper
      title={title}
      name={field.name}
      subtitle={subtitle}
      hasError={false}
      wasTouched={false}
      extraContent={extraContent}>
      <Select
        value={field.value}
        options={options}
        required={required}
        name={field.name}
        onBlur={handleBlur}
        searchable={searchable}
        handleClick={handleSelection}
        title={title}
        placeholder={placeholder}
        disabled={disabled}
        noOptionsText={noOptionsText}
        confirm={confirm}
      />
    </InputWrapper>
  );
};

export default SelectField;
